/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useState } from "react";
import LoginPageMeta from "./LoginPageMeta";
import Layout from "../../../Layouts/Layout";
import loginPageStyle from "./loginPageStyle";
import Container from "../../../../components/Container/Container";
import Paper from "@mui/material/Paper";
import LoginAction from "../../../../components/Login/LoginAction";
import { Box } from "@mui/material";

export default function LoginPage() {
  const [loginHeadline, setLoginHeadline] = useState("Anmelden");

  return (
    <Layout backgroundType={"landingpage"}>
      <LoginPageMeta />
      <Box sx={loginPageStyle.background}>
        <Container sx={loginPageStyle.loginContainer} responsiveWidth={false}>
          <Paper>
            <Box sx={loginPageStyle.loginTitle}>{loginHeadline}</Box>
            <Box sx={loginPageStyle.loginContent}>
              <LoginAction setLoginLayerTitle={setLoginHeadline} />
            </Box>
          </Paper>
        </Container>
      </Box>
    </Layout>
  );
}
